import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHistory, faHotel, faMailBulk, faUsers } from "@fortawesome/free-solid-svg-icons";
import { Col, Row, Card } from "@themesberg/react-bootstrap";

import { CircleChartWidget } from "../../../template/components/Widgets";
import { useContext } from "react";
import { PropertyContext } from "src/app/contexts/PropertyContext";
import { UserContext } from "src/app/contexts/UserContext";
import { faCheckCircle, faTimesCircle } from "@fortawesome/free-regular-svg-icons";
import { AdvertContext } from "src/app/contexts/AdvertContext";
import { ContactRequestContext } from "src/app/contexts/ContactRequestContext";
import { useEffect } from "react";
import { AuthContext } from "src/app/contexts/AuthContext";

const DashboardOverview = () => {
	const { propertyData, getAllPropertyData } = useContext(PropertyContext);
	const { userData, getAllUsersDataFromContext } = useContext(UserContext);
	const { adverts, getAllAdverts } = useContext(AdvertContext);
	const { contactRequest, getAllContactRequest } = useContext(ContactRequestContext);
	const { authData } = useContext(AuthContext);

	const statusData = [
		{
			id: 1,
			label: "Approved",
			value: propertyData?.filter((p) => p.publish_status === "approved")?.length || 0,
			color: "primary",
			icon: faCheckCircle,
		},
		{
			id: 2,
			label: "Rejected",
			value: propertyData?.filter((p) => p.publish_status === "rejected")?.length || 0,
			color: "danger",
			icon: faTimesCircle,
		},
		{
			id: 3,
			label: "Pending",
			value: propertyData?.filter((p) => p.publish_status === "pending")?.length || 0,
			color: "tertiary",
			icon: faHistory,
		},
	];

	useEffect(() => {
		getAllPropertyData();
		if (authData?.user_data?.roles?.[0]?.id === 1) {
			getAllUsersDataFromContext();
			getAllAdverts();
			getAllContactRequest();
		}
	}, []);

	return (
		<>
			<div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
				{/* <Dropdown className="btn-toolbar">
					<Dropdown.Toggle as={Button} variant="primary" size="sm" className="me-2">
						<FontAwesomeIcon icon={faPlus} className="me-2" />
						New Task
					</Dropdown.Toggle>
					<Dropdown.Menu className="dashboard-dropdown dropdown-menu-left mt-2">
						<Dropdown.Item className="fw-bold">
							<FontAwesomeIcon icon={faTasks} className="me-2" /> New Task
						</Dropdown.Item>
						<Dropdown.Item className="fw-bold">
							<FontAwesomeIcon icon={faCloudUploadAlt} className="me-2" /> Upload
							Files
						</Dropdown.Item>
						<Dropdown.Item className="fw-bold">
							<FontAwesomeIcon icon={faUserShield} className="me-2" /> Preview
							Security
						</Dropdown.Item>

						<Dropdown.Divider />

						<Dropdown.Item className="fw-bold">
							<FontAwesomeIcon icon={faRocket} className="text-danger me-2" /> Upgrade
							to Pro
						</Dropdown.Item>
					</Dropdown.Menu>
				</Dropdown>

				<ButtonGroup>
					<Button variant="outline-primary" size="sm">
						Share
					</Button>
					<Button variant="outline-primary" size="sm">
						Export
					</Button>
				</ButtonGroup> */}
			</div>

			<Row className="justify-content-md-center">
				<Col xs={12} sm={6} xl={4} className="mb-4">
					<Card border="light" className="shadow-sm p-4">
						<Card.Body>
							<Row className="d-block d-xl-flex align-items-center">
								<Col
									xl={5}
									className="text-xl-center d-flex align-items-center justify-content-xl-center mb-3 mb-xl-0"
								>
									<div
										className={`icon icon-shape icon-md icon-shape-tertiary rounded me-4 me-sm-0`}
									>
										<FontAwesomeIcon icon={faHotel} />
									</div>
									<div className="d-sm-none">
										<h5>{"Properties"}</h5>
										<h3 className="mb-1">{propertyData?.length || 0}</h3>
									</div>
								</Col>
								<Col xs={12} xl={7} className="px-xl-0">
									<div className="d-none d-sm-block">
										<h5>{"Properties"}</h5>
										<h3 className="mb-1">{propertyData?.length || 0}</h3>
									</div>
								</Col>
							</Row>
						</Card.Body>
					</Card>
				</Col>

				{authData?.user_data?.roles?.[0]?.id === 1 && (
					<Col xs={12} sm={6} xl={4} className="mb-4">
						<Card border="light" className="shadow-sm p-4">
							<Card.Body>
								<Row className="d-block d-xl-flex align-items-center">
									<Col
										xl={5}
										className="text-xl-center d-flex align-items-center justify-content-xl-center mb-3 mb-xl-0"
									>
										<div
											className={`icon icon-shape icon-md icon-shape-tertiary rounded me-4 me-sm-0`}
										>
											<FontAwesomeIcon icon={faUsers} />
										</div>
										<div className="d-sm-none">
											<h5>{"Users"}</h5>
											<h3 className="mb-1">{userData?.length || 0}</h3>
										</div>
									</Col>
									<Col xs={12} xl={7} className="px-xl-0">
										<div className="d-none d-sm-block">
											<h5>{"Users"}</h5>
											<h3 className="mb-1">{userData?.length || 0}</h3>
										</div>
									</Col>
								</Row>
							</Card.Body>
						</Card>
					</Col>
				)}

				<Col xs={12} sm={6} xl={4} className="mb-4">
					<CircleChartWidget title="Property Status Data" data={statusData} />
				</Col>
			</Row>

			<Row className="justify-content-md-center">
				{authData?.user_data?.roles?.[0]?.id === 1 && (
					<Col xs={12} sm={6} xl={4} className="mb-4">
						<Card border="light" className="shadow-sm p-4">
							<Card.Body>
								<Row className="d-block d-xl-flex align-items-center">
									<Col
										xl={5}
										className="text-xl-center d-flex align-items-center justify-content-xl-center mb-3 mb-xl-0"
									>
										<div
											className={`icon icon-shape icon-md icon-shape-tertiary rounded me-4 me-sm-0`}
										>
											<FontAwesomeIcon icon={faHotel} />
										</div>
										<div className="d-sm-none">
											<h5>{"Advertises"}</h5>
											<h3 className="mb-1">{adverts?.length || 0}</h3>
										</div>
									</Col>
									<Col xs={12} xl={7} className="px-xl-0">
										<div className="d-none d-sm-block">
											<h5>{"Advertises"}</h5>
											<h3 className="mb-1">{adverts?.length || 0}</h3>
										</div>
									</Col>
								</Row>
							</Card.Body>
						</Card>
					</Col>
				)}

				{authData?.user_data?.roles?.[0]?.id === 1 && (
					<Col xs={12} sm={6} xl={4} className="mb-4">
						<Card border="light" className="shadow-sm p-4">
							<Card.Body>
								<Row className="d-block d-xl-flex align-items-center">
									<Col
										xl={5}
										className="text-xl-center d-flex align-items-center justify-content-xl-center mb-3 mb-xl-0"
									>
										<div
											className={`icon icon-shape icon-md icon-shape-tertiary rounded me-4 me-sm-0`}
										>
											<FontAwesomeIcon icon={faMailBulk} />
										</div>
										<div className="d-sm-none">
											<h5>{"Contact Requests"}</h5>
											<h3 className="mb-1">{contactRequest?.length || 0}</h3>
										</div>
									</Col>
									<Col xs={12} xl={7} className="px-xl-0">
										<div className="d-none d-sm-block">
											<h5>{"Contact Requests"}</h5>
											<h3 className="mb-1">{contactRequest?.length || 0}</h3>
										</div>
									</Col>
								</Row>
							</Card.Body>
						</Card>
					</Col>
				)}

				{/* <Col xs={12} sm={6} xl={4} className="mb-4">
					<CircleChartWidget title="Property Status Data" data={statusData} />
				</Col> */}
			</Row>

			{/* <Row>
				<Col xs={12} xl={12} className="mb-4">
					<Row>
						<Col xs={12} xl={8} className="mb-4">
							<Row>
								<Col xs={12} className="mb-4">
									<PageVisitsTable />
								</Col>

								<Col xs={12} lg={6} className="mb-4">
									<TeamMembersWidget />
								</Col>

								<Col xs={12} lg={6} className="mb-4">
									<ProgressTrackWidget />
								</Col>
							</Row>
						</Col>

						<Col xs={12} xl={4}>
							<Row>
								<Col xs={12} className="mb-4">
									<BarChartWidget
										title="Total orders"
										value={452}
										percentage={18.2}
										data={totalOrders}
									/>
								</Col>

								<Col xs={12} className="px-0 mb-4">
									<RankingWidget />
								</Col>

								<Col xs={12} className="px-0">
									<AcquisitionWidget />
								</Col>
							</Row>
						</Col>
					</Row>
				</Col>
			</Row> */}
		</>
	);
};

export default DashboardOverview;
